import React, { Suspense } from 'react';

import { OptionalColorProps } from 'components/language-selector';
import { LazyComponent, lazyWithNullFallback } from 'components/layout/util';

const LanguageSelectorImpl: LazyComponent<OptionalColorProps> = lazyWithNullFallback(
  () => import('components/language-selector')
);

export const SubheaderLanguageSelector: React.FC = () => {
  return (
    <Suspense fallback={null}>
      <LanguageSelectorImpl color={Styles.color.grey.two} />
    </Suspense>
  );
};
